export default __webpack_public_path__ + "static/advanced_button-f53dca4023cb6f575f98116941a81d86.jpg";